// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-UBX","comment":"styles_comment__3a68X"};